import { render, staticRenderFns } from "./MonthlyPayrollReport.vue?vue&type=template&id=0ed468d8"
import script from "./MonthlyPayrollReport.vue?vue&type=script&lang=js"
export * from "./MonthlyPayrollReport.vue?vue&type=script&lang=js"
import style0 from "./MonthlyPayrollReport.vue?vue&type=style&index=0&id=0ed468d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports